/**
 * @fileoverview SessionProvider for Better Auth compatibility
 * 
 * @purpose Provides a SessionProvider component for backward compatibility.
 *          Better Auth doesn't require a SessionProvider wrapper - the useSession hook works directly.
 *          This component is kept for backward compatibility but doesn't do anything.
 * 
 * @usage Import in app layout:
 *        import { SessionProvider } from '@korvo/core/components/providers'
 * 
 * @ownership Core infrastructure - authentication providers
 */

'use client'

/**
 * SessionProvider - Better Auth
 * 
 * Better Auth doesn't require a SessionProvider wrapper.
 * The useSession hook works directly with the auth client.
 * This component is kept for backward compatibility but doesn't do anything.
 */
export function SessionProvider({ children }: { children: React.ReactNode }) {
  // Better Auth doesn't need a provider - hooks work directly
  return <>{children}</>
}
